import { copy } from "shared/assets";
import { IStatus } from "shared/types";
import { IUserPermissions } from "shared/utils";
import { VENUE_PATHS } from "Venues/router";
import { IActionDropdownItem } from "shared/components";
import { SuggestEditFormType } from "Venues/components";
import { VenueRouteParams } from "..";

const { actions: actionsCopy } = copy;

export const getStageActions = ({
  userPermissions,
  stageId,
  openDeleteStageModal,
  openSuggestStageEditModal,
  pushRoute,
}: {
  userPermissions: IUserPermissions;
  stageId: string;
  openDeleteStageModal: (id: string) => void;
  openSuggestStageEditModal: (props: { type: SuggestEditFormType; stageId: string }) => void;
  pushRoute: (path: string, options?: VenueRouteParams) => void;
}): IActionDropdownItem[] => {
  const actions: IActionDropdownItem[] = [];
  if (userPermissions.EDIT) {
    actions.push({
      label: actionsCopy.edit,
      handleClick: () => pushRoute(VENUE_PATHS.EDIT_STAGE, { stageId }),
      dataTestId: "edit",
    });
  }
  if (userPermissions.DELETE) {
    actions.push({
      label: actionsCopy.delete,
      status: IStatus.error,
      handleClick: () => openDeleteStageModal(stageId),
      dataTestId: "delete",
    });
  }

  if (actions.length !== 0) {
    return actions;
  }

  return [
    {
      label: actionsCopy.suggestEdit,
      handleClick: () => openSuggestStageEditModal({ type: "Stage", stageId }),
      dataTestId: "suggest_edit",
    },
  ];
};
